module.exports = __webpack_public_path__ + "img/logo2.87d3a199.png";